// skills/mining/index.js
// Mining skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import { renderMiningUI, updateMiningUI, initMiningUI, toggleMining, upgradePickaxe } from './miningUI.js';

/**
 * Mining skill configuration
 */
const miningConfig = {
    id: 'mining',
    name: 'Mining',
    icon: '<span class="mining-icon"></span>',
    iconImage: 'assets/icons/skill_icons/mining.png',
    description: 'Extract ores and gems from rocks',

    // Future tabs for sub-pages
    tabs: [
        { id: 'rocks', name: 'Rocks', default: true },
        // { id: 'smelting', name: 'Smelting' },
        // { id: 'talents', name: 'Talents' },
    ],

    // CSS path for dynamic loading (optional - uses base styles)
    // css: '/styles/skills/mining.css',

    /**
     * Render the mining interface
     * @param {Object} params - Render params (tab, etc.)
     */
    render(params = {}) {
        const { tab = 'rocks' } = params;

        // For now, all tabs render the same rocks view
        // Future: switch based on tab
        renderMiningUI();
    },

    /**
     * Update function called each game tick
     */
    update() {
        updateMiningUI();
    },

    /**
     * Initialization function called once when skill is first accessed
     */
    init() {
        initMiningUI();
    },

    /**
     * Cleanup function called when navigating away
     */
    cleanup() {
        // Nothing to cleanup for now
    }
};

// Self-register with skill registry
skillRegistry.register('mining', miningConfig);

// Expose to window for onclick handlers (legacy support)
if (typeof window !== 'undefined') {
    window.miningUI = {
        toggleMining,
        upgradePickaxe
    };
}

export default miningConfig;
